'use client';
import commonStyles from '@/app/(website)/commonStyles.module.scss';
import styles from './bookMeeting.module.scss';

import Cal from '@calcom/embed-react';

export default function BookMeeting() {
  return (
    <section className={`${styles.meeting} ${commonStyles.sectionContent}`}>
      <Cal calLink="team/baseline/demo" config={{ theme: 'light' }}></Cal>
    </section>
  );
}
